// extracted by mini-css-extract-plugin
module.exports = {"mission":"styles_mission__2XsjA","mission-body":"styles_mission-body__3345G","mission-statement":"styles_mission-statement__1Iv2k"};